import React, { useEffect, useState } from "react";
import { fmtDate, rupees } from "../Insights/format";
import { STATEMENT_LIMIT, fetchStatements, standingLine } from "./riderReportData";

const AMOUNTS = [
  ["delivery_charges", "Delivery charges"],
  ["tips", "Tips"],
  ["incentive", "Incentive"],
  ["special_incentive", "Special"],
  ["correction", "Correction"],
  ["salary", "Salary"],
  ["cash_collected", "Cash collected"],
  ["cash_in_hand_after", "Cash in hand after"],
];

const Money = ({ value, strong }) => (
  <span className={!value ? "stl-zero" : strong ? "stl-strong" : undefined}>{rupees(value)}</span>
);

export default function RiderStatements({ riderId, range, version }) {
  const [data, setData] = useState({ rows: [], summary: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    setLoading(true);
    fetchStatements(riderId, range).then((result) => {
      if (!live) return;
      setData(result);
      setLoading(false);
    });
    return () => {
      live = false;
    };
  }, [riderId, range, version]);

  const { rows, summary } = data;
  const count = rows.length >= STATEMENT_LIMIT ? `latest ${STATEMENT_LIMIT}` : `${rows.length}`;

  return (
    <div className="stl-card stl-table-card">
      <div className="stl-table-bar">
        <div className="stl-table-bar__title">
          <h2 className="stl-title">Salary statements</h2>
          <span className="stl-subtitle">
            {count} salary statement{rows.length === 1 ? "" : "s"}
            {summary ? ` · ${standingLine(summary)}` : ""}
          </span>
        </div>
      </div>
      <div className="stl-scroll">
        <table className="stl-table">
          <thead>
            <tr>
              <th className="stl-left">Day</th>
              <th>Orders</th>
              {AMOUNTS.map(([key, title]) => (
                <th key={key}>{title}</th>
              ))}
              <th className="stl-left">Note</th>
              <th className="stl-left">Submitted by</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={AMOUNTS.length + 4} className="stl-no-match">
                  {loading ? "Loading statements…" : "No salary submitted in this period"}
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row.id}>
                  <td className="stl-left">{fmtDate(row.date)}</td>
                  <td>{row.orders}</td>
                  {AMOUNTS.map(([key]) => (
                    <td key={key}>
                      <Money value={row[key]} strong={key === "salary"} />
                    </td>
                  ))}
                  <td className="stl-left rider-note">{row.notes || "—"}</td>
                  <td className="stl-left">{row.submitted_by || "—"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
